import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { Verify } from "./pages/Verify";
import { Home } from "./pages/Home";
import { Form } from "./pages/Form";
import { Ticket } from "./pages/Ticket";
import { Header } from "./Components/Header/Header";
import { Sidebar } from "./Components/Sidebar/Sidebar";
import { Notfound } from "./pages/Notfound";
import { Footer } from "./Components/Footer/Footer";
import { ReleaseNotes } from "./pages/ReleaseNotes";
import { Resources } from "./pages/Resources";
import { Analytics } from "./pages/Analytics";
import { Login } from "./pages/Login";
import { Workload } from "./pages/Workload";
import { Resource } from "./pages/Resource";
import { LoaList } from "./pages/LoaList";
import { LoaForm } from "./pages/LoaForm";
import { LoaDetail } from "./pages/LoaDetail";
import { RcsSupport } from "./pages/RcsSupport";
import { UserManagement } from "./pages/UserManagement";
import { AssistantStatus } from "./pages/AssistantStatus";
import { TicketProvider } from "./context/TicketContext";

function App() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/auth/login";

  return (
    <TicketProvider>
    <div className="flex flex-col h-screen overflow-hidden">
      {!isLoginPage && <Header />}
      <div className="flex flex-1 min-h-0">
        {!isLoginPage && <Sidebar />}
        {/* Only this region scrolls — Header and Sidebar stay fixed on screen.
            min-h-0 overrides the flex-item default of min-height:auto, which
            would otherwise let this div grow to fit its content instead of
            being clamped to the row's height (and scrolling internally). */}
        <div className="flex-1 min-w-0 min-h-0 overflow-y-auto flex flex-col">
          <div className="flex-1">
            <Routes>
              <Route path="/auth/login" element={<Login />} />
              <Route path="/auth/verify/:token" element={<Verify />} />
              <Route exact path="/Dashboard" element={<Home />} />
              <Route exact path="/Form" element={<Form />} />
              <Route exact path="/Ticket/:ticketID" element={<Ticket />} />
              <Route path="/ReleaseNotes" element={<ReleaseNotes />} />
              <Route path="/Resources" element={<Resources />} />
              <Route path="/Analytics" element={<Analytics />} />
              <Route path="/Workload" element={<Workload />} />
              <Route path="/Resource/:ResourceId" element={<Resource />} />
              <Route exact path="/LOA" element={<LoaList />} />
              <Route exact path="/LOA/new" element={<LoaForm />} />
              <Route exact path="/LOA/:loaId" element={<LoaDetail />} />
              <Route exact path="/RcsSupport" element={<RcsSupport />} />
              <Route exact path="/Admin/Users" element={<UserManagement />} />
              <Route exact path="/AssistantStatus" element={<AssistantStatus />} />
              <Route path="*" element={<Notfound />} />
            </Routes>
          </div>
          {/* {location.pathname !== "/ReleaseNotes" && !isLoginPage && (
            <Footer className="w-full bg-gray-900" />
          )} */}
        </div>
      </div>
    </div>
    </TicketProvider>
  );
}

export default App;
